




































































import { Vue, Component, PropSync } from 'vue-property-decorator'
import moment from 'moment'
import { VueRecaptcha } from 'vue-recaptcha'

import config from '@/config'
import { CallDetailsInformation } from '@/types'
import { sendReport, getRecaptchaSiteKey } from '@/utils'

@Component({
  components: { VueRecaptcha },
  filters: {
    formatTime (time: string) {
      return time ? moment(time, ['HH:mm']).format('h:mm A') : null
    }
  }
})
export default class Review extends Vue {
  @PropSync('formStep')
  private step!: 'Details' | 'Review' | 'Confirmation' | 'Failed'

  @PropSync('callDetails')
  private data!: CallDetailsInformation

  private loading = false

  private isCaptchaVerified = false

  private recaptchaToken = '';

  private async onSubmit () {
    if (this.isCaptchaVerified) {
      try {
        this.loading = true
        this.$gtag.event('Submit', {
          // eslint-disable-next-line
          event_category: this.isMagenta ? 'T-Mobile' : 'Metro'
        })
        const response = await sendReport(this.data, this.recaptchaToken)
        this.$gtag.event('Success Status ' + response.status, {
          // eslint-disable-next-line
          event_category: this.isMagenta ? 'T-Mobile' : 'Metro'
        })
        this.step = 'Confirmation'
      } catch (e) {
        console.error(e)
        this.$gtag.event('Error Status ' + e?.response?.status, {
          // eslint-disable-next-line
          event_category: this.isMagenta ? 'T-Mobile' : 'Metro'
        })
        this.step = 'Failed'
      } finally {
        this.loading = false
      }
    }
  }

  private async onCaptchaVerified (recaptchaToken: string) {
    this.recaptchaToken = recaptchaToken
    this.isCaptchaVerified = true
  }

  private async onCaptchaExpired () {
    this.isCaptchaVerified = false
    this.recaptchaToken = ''
  }

  private get getRecaptchaSiteKey () {
    return getRecaptchaSiteKey()
  }

  private get formattedPhoneNumber () {
    const phoneNumber = this.data.number

    function formatPhoneNumber (phoneNumber: string) {
      const npa = phoneNumber.slice(0, 3)
      const nxx = phoneNumber.slice(3, 6)
      const local = phoneNumber.slice(6, 10)

      return `(${npa}) ${nxx}-${local}`
    }

    if (phoneNumber.length === 10) {
      return formatPhoneNumber(phoneNumber)
    } else if (phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
      return '+1 ' + formatPhoneNumber(phoneNumber.slice(-10))
    } else {
      return phoneNumber
    }
  }

  private get isMagenta () {
    return config.isMagenta
  }

  mounted () {
    // if the number being reported matches the number(s) we use for automated healthchecks, allow bypass of recaptcha
    this.isCaptchaVerified = config.healthCheckNumbers.indexOf(this.data.number) > -1
  }
}

